import type {IntlShape} from 'react-intl';
import {matrixService} from '../../../services/matrixService';
import {isServiceParticipant} from '../../../utils/aiBotUtils';
import {groupSurfaceMessages as m} from './groupMessages';

const MAX_NAMES = 3;

/** First names of the other room members, the people who can rejoin from Active calls (D-CONF-06/S02). */
export const rejoinNamesOf = (roomId: string | undefined, localUserId: string | undefined): readonly string[] =>
    (roomId ? matrixService.getRoom(roomId)?.getJoinedMembers() ?? [] : [])
        .filter(member => member.userId !== localUserId && !isServiceParticipant(member.userId))
        .map(member => (member.name || member.userId).split(' ')[0])
        .sort((left, right) => left.localeCompare(right));

export const aloneBodyOf = (intl: IntlShape, names: readonly string[]): string => {
    if (names.length === 0) {
        return intl.formatMessage(m.aloneBody);
    }
    const shown = names.length > MAX_NAMES ? [...names.slice(0, MAX_NAMES - 1), intl.formatMessage(m.othersCount, {count: names.length - (MAX_NAMES - 1)})] : names;
    return intl.formatMessage(m.aloneBodyRejoin, {names: intl.formatList(shown, {type: 'conjunction'})});
};
